import { useTranslation } from 'react-i18next';
import { LOGO_VARIANTS, MODULE_KEY } from '@/constants/modules';
import { Card } from '@/components/ui/card';
import { LoadingSpinner } from '@/components/common/LoadingSpinner';
import { QueryErrorState } from '@/components/admin/shared/QueryErrorState';
import { useHasWorkspaceModule } from '@/hooks/useHasWorkspaceModule';
import { useWorkspaceBrandingQuery } from '@/hooks/useWorkspaceBrandingQuery';
import { BrandNameForm } from './BrandNameForm';
import { LogoCard } from './LogoCard';
import { CustomDomainSection } from './CustomDomainSection';

export function BrandingSection() {
  const { t } = useTranslation('modules');
  const hasBrandingModule = useHasWorkspaceModule(MODULE_KEY.branding);
  const brandingQuery = useWorkspaceBrandingQuery(hasBrandingModule);

  if (brandingQuery.isLoading === true) {
    return (
      <div className="py-16 flex justify-center">
        <LoadingSpinner className="w-7 h-7" />
      </div>
    );
  }

  if (brandingQuery.isError === true || brandingQuery.data === undefined) {
    return (
      <QueryErrorState
        onRetry={function retry() {
          brandingQuery.refetch();
        }}
      />
    );
  }

  const brandingData = brandingQuery.data;

  return (
    <div className="space-y-6">
      <BrandNameForm brandName={brandingData.brandName} />

      <Card padding="md">
        <h2 className="text-sm font-bold text-zooindigo">{t('branding.logosTitle')}</h2>
        <p className="text-xs text-zoomuted mt-1 mb-5">{t('branding.logosHint')}</p>
        <div className="grid grid-cols-[repeat(auto-fill,minmax(11rem,1fr))] gap-4">
          {LOGO_VARIANTS.map(function renderLogoCard(variant) {
            return (
              <LogoCard key={variant} variant={variant} logoUrl={brandingData.logos[variant]} />
            );
          })}
        </div>
      </Card>

      <CustomDomainSection />
    </div>
  );
}
